import { useTranslation } from 'react-i18next';

import { useAuthContext } from '../../../../auth/context/AuthProvider';
import { logoutButton } from '../libs/styles.css';

export const UserFormLogout = () => {
  const { logout } = useAuthContext();
  const { t } = useTranslation('user_info');

  return (
    <button type="button" className={logoutButton} onClick={logout}>
      {t('user_info:logout')}
    </button>
  );
};
